export default __webpack_public_path__ + "static/media/Sample Video.cbe331fd.mp4";